import { UNLIMITED_ADVANCE_CHAPTERS_COUNT } from '@app/domains/champion/constants';

export const convertMinusException = (count: number) =>
    count === UNLIMITED_ADVANCE_CHAPTERS_COUNT ? Number.MAX_VALUE : count;
